import { render, staticRenderFns } from "./luckyLotteryCreateAndEdit.vue?vue&type=template&id=3b004fc7&scoped=true"
import script from "./luckyLotteryCreateAndEdit.vue?vue&type=script&lang=js"
export * from "./luckyLotteryCreateAndEdit.vue?vue&type=script&lang=js"
import style0 from "./luckyLotteryCreateAndEdit.vue?vue&type=style&index=0&id=3b004fc7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b004fc7",
  null
  
)

export default component.exports